"use client";

/**
 * Недавно выбранные признаки проктора — как «Недавние» в глобальном поиске:
 * список живёт в localStorage этого браузера, привязан к пользователю, чтобы на
 * общем компьютере один проктор не видел выбор другого.
 */

const RECENT_KEY = "te-verdict-recent-actions";
const RECENT_LIMIT = 5;

interface OwnedRecent {
  owner: string;
  items: string[];
}

export function readRecentActions(owner: string | null): string[] {
  if (typeof window === "undefined" || !owner) return [];

  try {
    const raw = window.localStorage.getItem(RECENT_KEY);
    const parsed = raw ? (JSON.parse(raw) as OwnedRecent) : null;

    if (!parsed || parsed.owner !== owner || !Array.isArray(parsed.items)) return [];

    return parsed.items.filter((item) => typeof item === "string").slice(0, RECENT_LIMIT);
  } catch {
    return [];
  }
}

export function rememberRecentAction(owner: string | null, raw: string): string[] {
  const items = [raw, ...readRecentActions(owner).filter((item) => item !== raw)].slice(
    0,
    RECENT_LIMIT,
  );

  if (typeof window === "undefined" || !owner) return items;

  try {
    window.localStorage.setItem(RECENT_KEY, JSON.stringify({ owner, items }));
  } catch {
    return items;
  }

  return items;
}
